import { render, staticRenderFns } from "./select-case-related-request.vue?vue&type=template&id=07e0e386&"
import script from "./select-case-related-request.vue?vue&type=script&lang=js&"
export * from "./select-case-related-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports